import React from 'react'
import './skills.css'
import Frontend from './Frontend';
import Backend from './Backend'
import Mobile from './Mobile'

const Skills = ({ isDarkMode}) => {
  const bodyClass = `skills section ${isDarkMode ? "dark-mode" : ""}`;

  return (
    <section className={bodyClass} id="skills">
         <h2 className="section__title">Skills</h2>
        <span className="section__subtitle">My Technical Skills</span>

        <div className="skills__container container grid">
        <Frontend isDarkMode={isDarkMode} />
        <Backend  isDarkMode={isDarkMode}/>
        <Mobile isDarkMode={isDarkMode}/>
        </div>
        
    </section>
  )
}

export default Skills
